<se-fe-card [seFeDataFullHeight]="true">
  <se-fe-card-header seFeDataTitle="Product bundle details" [seFeDataHeavyBorder]="true">
    <div seFeCardHeaderActions>
      <bundle-details-modal
        [bundle]="bundle()"
        [error]="error"
        (save)="updateBundle($event)"
        class="item-detail-edit-modal item-detail-modal"
        id="edit-modal"></bundle-details-modal>
    </div>
  </se-fe-card-header>
  <se-fe-card-content id="item-detail__item-details">
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <se-fe-form-field [seFeDataConfig]="productNameLabel"></se-fe-form-field>
        <p class="product-name">{{ bundle()?.name || '--' }}</p>
      </se-fe-grid-cell>
    </se-fe-grid>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <div class="bundledetail">
          <se-fe-form-field [seFeDataConfig]="productDescriptionLabel"></se-fe-form-field>
          <div
            class="product-description quill-display-content ql-editor"
            [innerHtml]="bundle()?.description || '--'"></div>
        </div>
      </se-fe-grid-cell>
    </se-fe-grid>
  </se-fe-card-content>
</se-fe-card>
